




























import { Component, Prop, Vue } from "vue-property-decorator";
import { decodeVehicleNumber } from "@/services/vehicleNumberDecoder";

@Component
export default class ArrivalProgressBar extends Vue {
  @Prop({ default: null })
  etaDate!: string | null;

  @Prop({ default: null })
  etaTime!: string | null;

  @Prop({ default: null })
  ambulanceId!: string | null;

  currentTime: Date = new Date();
  timerInterval: any = null;

  mounted() {
    this.timerInterval = setInterval(() => {
      this.currentTime = new Date();
    }, 1000);
  }

  beforeDestroy() {
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }
  }

  get ambulanceIcon(): string {
    if (!this.ambulanceId) return "fa fa-ambulance";
    const { vehicle, specialCase } = decodeVehicleNumber(this.ambulanceId);
    const isHelicopter = vehicle === "MMT" && specialCase === "Helikopter";
    return isHelicopter ? "fa fa-helicopter" : "fa fa-ambulance";
  }

  get etaParsed(): Date | null {
    if (!this.etaDate || !this.etaTime) {
      return null;
    }
    const [day, month, year] = this.etaDate.split("-");
    const parsed = new Date(`${year}-${month}-${day}T${this.etaTime}`);
    return isNaN(parsed.getTime()) ? null : parsed;
  }

  get etaProgressPercentage(): number {
    const eta = this.etaParsed;
    if (!eta) {
      return 0;
    }
    const windowMs = 30 * 60 * 1000;
    const remaining = eta.getTime() - this.currentTime.getTime();
    if (remaining <= 0) {
      return 100;
    }
    return Math.max(0, ((windowMs - remaining) / windowMs) * 100);
  }

  get etaColor(): string {
    const eta = this.etaParsed;
    if (!eta) {
      return "#757575";
    }
    const diff = eta.getTime() - this.currentTime.getTime();
    const minutes = Math.floor(diff / 60000);
    if (diff <= 0) {
      return "#4CAF50";
    }
    if (minutes <= 2) {
      return "#F44336";
    }
    if (minutes <= 5) {
      return "#FF9800";
    }
    return "#2196F3";
  }

  get etaCountdownText(): string {
    const eta = this.etaParsed;
    if (!eta) {
      return "";
    }
    const diff = eta.getTime() - this.currentTime.getTime();
    if (diff <= 0) {
      return "Aangekomen";
    }
    const minutes = Math.floor(diff / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, "0")}`;
  }
}
